module.exports = __webpack_public_path__ + "img/payment_failed.a84779b.svg";